import classNames from 'classnames';
import Image from 'next/image';

import {
  Characteristics,
  ActivateBlock,
  HiddenList,
  Button,
  ProductStatus,
} from '@/ui/index';
import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import TextBlock from '@/ui/TextBlock/TextBlock';
import AdditionalInformation from '@/ui/AdditionalInformation/AdditionalInformation';
import { ArrowRight } from '@/icons/index';

import { Questions } from '../../roaming';

import styles from './styles.module.scss';

const CaptionBlock = ({ captionData }) => {
  return (
    <div
      className={styles['caption-block']}
      itemScope
      itemType='http://schema.org/Article'
    >
      {captionData?.title && (
        <SectionTitle
          titleModify={classNames([
            'title--medium',
            styles['caption-block__title'],
          ])}
        >
          {captionData.title}
        </SectionTitle>
      )}
      {captionData?.description && (
        <TextBlock
          className={classNames([
            'text--large',
            'text--shadow-black',
            styles['caption-block__text'],
          ])}
        >
          {captionData.description}
        </TextBlock>
      )}
    </div>
  );
};

const InternetBlock = ({ contentData }) => {
  return (
    <div
      className={styles.internetContainer}
      itemScope
      itemType='http://schema.org/Service'
    >
      <div className={styles.containerTitle}>{contentData?.title}</div>
      <div className={styles.internetBlock}>
        <div className={styles.internetInfo}>
          <div className={styles.internetDescription}>
            {contentData?.description}
          </div>
          <Button
            className={styles.button}
            Component={'router'}
            href={contentData?.button_slug}
          >
            {contentData?.button_text} <ArrowRight width={20} />
          </Button>
        </div>
        <div className={styles.internetImage}>
          <Image
            src={contentData?.image}
            alt={contentData?.description}
            title={contentData?.description}
            loading='lazy'
            layout='fill'
          />
        </div>
      </div>
    </div>
  );
};
const SingleTariffsContent = ({ data }) => {
  const isDataAvailable = !Object.values(data?.activation).every(
    (value) => !value,
  );
  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/Service'
    >
      <div className={'wrapper'}>
        <div className={styles.block}>
          <div className={styles.infoBlock}>
            <div
              className={classNames([
                styles.characteristicsList,
                {
                  [styles['characteristicsList--small']]:
                    data.characteristics.caption,
                },
              ])}
            >
              {data?.general_information?.description && (
                <CaptionBlock captionData={data?.general_information} />
              )}
              {data?.general_information?.sections &&
                Object.keys(data?.general_information?.sections)?.length >
                  0 && (
                  <Questions
                    questions={data?.general_information}
                    className='questions--small'
                    titleModify='title--medium'
                    isSmall
                    hasGeneralInfo={true}
                  />
                )}
              {data?.terms && Object.keys(data?.terms)?.length > 0 && (
                <ProductStatus
                  statusData={data.terms}
                  titleModify='title--medium'
                />
              )}
              {data?.quick_commands &&
                Object.keys(data?.quick_commands)?.length > 0 && (
                  <ProductStatus
                    statusData={data?.quick_commands}
                    titleModify='title--medium'
                  />
                )}
              {data?.characteristics &&
                Object.keys(data?.characteristics)?.length > 0 && (
                  <Characteristics items={data.characteristics} />
                )}
              {data?.additional_information &&
                Object.keys(data?.additional_information)?.length > 0 && (
                  <AdditionalInformation items={data?.additional_information} />
                )}
              {data?.additional_information?.points &&
                Object.keys(data?.additional_information?.points)?.length >
                  0 && <HiddenList items={data?.additional_information} />}
              {data?.special_notes?.sections &&
                Object.keys(data?.special_notes?.sections)?.length > 0 && (
                  <Questions
                    questions={data?.special_notes}
                    titleModify='title--medium'
                    isSmall
                  />
                )}

              {Object.keys(data?.learn_more_banner)?.length !== 0 && (
                <InternetBlock contentData={data.learn_more_banner} />
              )}
            </div>
          </div>
          {isDataAvailable && (
            <div className={styles.actionsBlock}>
              <ActivateBlock
                data={data?.activation}
                tariff={data?.tariff}
                isSubscrable={data?.tariff?.isSubscribable}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleTariffsContent;
